import PerformType from "@/domain/PerformType";

export const Delivered = new PerformType(0, "Доставлен")
export const ReceiverDead = new PerformType(1, "Адресат умер (Олувчи вафот этган)")
export const ReceiverNotLivesThere = new PerformType(2, "Адресат по указанному адресу не проживает (Олувчи кўрсатилган манзилда яшамайди)")
export const IncompleteAddress = new PerformType(3, "Указан не полный адрес (Тўлиқ манзил кўрсатилмаган)")
export const ReceiverRefused = new PerformType(4, "Адресат от получения отказался (Олувчи қабул қилишдан бош тортди)")
export const ReceiverNotAtHome = new PerformType(5, "Нет дома (Уйда йўқ)")
export const ReceiverDidntAppearOnNotice = new PerformType(6, "Не явился по извещению (Хабарнома қолдирилди олувчи келмади)")
export const InvalidAddress = new PerformType(7, "Адрес не определен (Манзил аниқланмади)")
export const TryPerform = new PerformType(8, "Попытка вручения")
export const OrganizationWithGivenAddressNotFound = new PerformType(9, "По указанному адресу организация не найдена (Кўрсатилган манзилдан ташкилот топилмади)")
